/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigScopeDetailsBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return LockConfigScopeDetailsBase.fixupPrototype; }

    static newInstance(model: Partial<LockConfigScopeDetailsBase>): LockConfigScopeDetailsBase {
        let obj = Object.assign(new LockConfigScopeDetailsBase(), model);
        LockConfigScopeDetailsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigScopeDetailsBase>): LockConfigScopeDetailsBase {
        if (!model) return null;
        return LockConfigScopeDetailsBase.newInstance(<LockConfigScopeDetailsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigScopeDetailsBase) {
        if (!obj) return;

        models.LockConfigScopeDetailsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigScopeDetailsBase): boolean {
        switch (obj.type)
        {
            case "LockConfigDetailsBaseForServiceAccount":
                Object.setPrototypeOf(obj, models.LockConfigScopeDetailsBaseForServiceAccount.prototype);
                break;
            case "LockConfigScopeDetailsForAwsServiceAccount":
                Object.setPrototypeOf(obj, models.LockConfigScopeDetailsForAwsServiceAccount.prototype);
                break;
            case "LockConfigScopeDetailsForAzureServiceAccount":
                Object.setPrototypeOf(obj, models.LockConfigScopeDetailsForAzureServiceAccount.prototype);
                break;
            case "LockConfigScopeDetailsForGcpServiceAccount":
                Object.setPrototypeOf(obj, models.LockConfigScopeDetailsForGcpServiceAccount.prototype);
                break;
            case "LockConfigScopeDetailsForTenant":
                Object.setPrototypeOf(obj, models.LockConfigScopeDetailsForTenant.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof LockConfigScopeDetailsBase)[] {
        return [
            models.LockConfigScopeDetailsBaseForServiceAccount,
            models.LockConfigScopeDetailsForAwsServiceAccount,
            models.LockConfigScopeDetailsForAzureServiceAccount,
            models.LockConfigScopeDetailsForGcpServiceAccount,
            models.LockConfigScopeDetailsForTenant,
        ];
    }

    fixupFields() {
    }

}
